import { ReactNode } from 'react'

import * as S from './styles'

interface IContainerProps {
  children?: ReactNode
  className?: string
}

const Container = ({ children, className }: IContainerProps) => (
  <S.Container className={className}>{children}</S.Container>
)

export { Container }
export type { IContainerProps }
